import { render, staticRenderFns } from "./law-header.vue?vue&type=template&id=a130d66a&scoped=true"
import script from "./law-header.vue?vue&type=script&lang=js"
export * from "./law-header.vue?vue&type=script&lang=js"
import style0 from "./law-header.vue?vue&type=style&index=0&id=a130d66a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a130d66a",
  null
  
)

export default component.exports